module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-available-yellow-07b292.svg";